export function asPounds(weight: number, unit: string) {
  return unit === 'kg' ? weight * 2.2046226218 : weight;
}

export function fromPounds(weight: number, unit: string) {
  return unit === 'kg' ? weight / 2.2046226218 : weight;
}
